import axios from 'axios'

export const company = {
  namespaced: true,
  state: {
    detail: {}
  },

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    clear(state) {
      state.detail = {}
    }
  },

  actions: {
    async detail({ commit }) {
      const {
        VUE_APP_URL = "",
        VUE_APP_URL_LANG = "",
        VUE_APP_URL_TYPE = "",
        VUE_APP_URL_NAME = ""
      } = process.env;
      const url = `${VUE_APP_URL}${VUE_APP_URL_LANG}${VUE_APP_URL_TYPE}${VUE_APP_URL_NAME}`;
      await axios
        .get(`${url}company-detail.json`)
        .then(res => {
          commit('setDetail', res.data)
        }).catch(err => console.log("err", err))
    },
    clearStore({ commit }) {
      commit('clear')
    }
  }
}
